import React, { Component } from 'react';
import { connect, Provider } from 'react-redux';

import { PAGE_ROUTES } from '../../constants/pageRoutes';
import UserMenu from '../global/user-menu-component';
import { store } from '../../store';
import { BrowserRouter } from 'react-router-dom';

const mapStateToProps = state => ({
  global: state.Global
});

class HeaderButtons extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { token } = this.props.global;
    return (
      <div>
        {
          !token ?
            <div className="before-login-class">
              <a className="btn primary signin-btn" href={`/app/#${PAGE_ROUTES.LOGIN}`}>Sign In</a>
              <a className="btn primary signup-btn" href={`/app/#${PAGE_ROUTES.CREATE_ACCOUNT}`}>Sign Up</a>
            </div>
            : <BrowserRouter><Provider store={store}><UserMenu /></Provider></BrowserRouter> 
        }
      </div>
    )
  }
}

export default connect(mapStateToProps)(HeaderButtons);
